import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useLayoutEffect(() => {
    const lenis = (window as any).lenis as Lenis | undefined;

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    if (!lenis) return;

    lenis.scrollTo(0, { immediate: true });
    setTimeout(() => lenis.scrollTo(0, { immediate: true }), 50);
    setTimeout(() => lenis.scrollTo(0, { immediate: true }), 200);
  }, [pathname, search, hash]);

  return null;
}

